import { defineRecipe } from "@chakra-ui/react";

export default defineRecipe({
  base: {
    borderRadius: "md",
    fontWeight: "semibold",
  },
  variants: {
    variant: {
      solid: {
        borderWidth: "0",
        boxShadow: "button.solid",

        _hover: {
          background: "colorPalette.solid/90",
          boxShadow: `none`,
        },

        _active: {
          background: "colorPalette.solid!important",
          boxShadow: "button.solid.active!important",
        },
      },

      surface: {
        background: "white",
        boxShadow: "button.surface",

        _hover: {
          background: "gray.50",
        },
      },
    },
  },
});
